import { cva } from 'class-variance-authority'

// Keep the shared link styles usable without loading the portal menu implementation.
export const navigationMenuTriggerStyle = cva(
  'group inline-flex w-max items-center justify-center rounded-full px-5 py-3 font-semibold transition-colors hover:bg-accent/50 hover:text-accent-foreground focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50',
)
